import { Injectable } from '@angular/core';
import { Bid, BID_SOURCE_TYPE } from 'cargo-chief-commons';
import { PushNotificationService } from '@service/pushNotification/push-notification.service';

// CN-8475: attribute the notification to whoever acted last. A COUNTERED/ACCEPTED transition can be
// driven by the carrier OR by the broker countering/accepting back; the latest bidHistory sourceType
// tells us which. Broker-sourced entries use BID_SOURCE_TYPE.CUSTOMER.
const BROKER_ACTED_LAST = (bid: Bid): boolean => {
	const histories = bid?.bidHistories;
	if (!histories || histories.length === 0) {
		return false;
	}
	const latest = [...histories].sort((a, b) => (b.created > a.created ? 1 : -1))[0];
	return latest?.sourceType === BID_SOURCE_TYPE.CUSTOMER;
};

const bidMapping = {
	COUNTERED: (bid: Bid) =>
		BROKER_ACTED_LAST(bid)
			? `You countered ${bid.carrierBusinessName}'s offer.`
			: `${bid.carrierBusinessName} countered bid.`,
	ACCEPTED: (bid: Bid) =>
		BROKER_ACTED_LAST(bid)
			? `You accepted ${bid.carrierBusinessName}'s offer.`
			: `${bid.carrierBusinessName} accepted bid.`,
};

@Injectable({
	providedIn: 'root',
})
export class PushNotificationV2Service {
	constructor(private pushNotificationService: PushNotificationService) {}

	public sendBidNotification(type: string, bid: Bid, quoteLane: string) {
		if (!bidMapping[type]) return;

		this.pushNotificationService.generateNotification([{
			title: bidMapping[type](bid),
			alertContent: quoteLane
		}]);
	}
}
